import { parseTemplate } from 'url-template';
import { InternalHttpServiceRequestHeaders } from '../http.service';

export const urlTemplateInterceptor = (config: InternalHttpServiceRequestHeaders): InternalHttpServiceRequestHeaders => {
  const { url: originalUrl, pathParams } = config;

  if (!originalUrl) {
    return config;
  }

  if (/\{.*?\}/.test(originalUrl) && pathParams) {
    const url = parseTemplate(originalUrl).expand(pathParams);
    return {
      ...config,
      url,
      pathParams,
    };
  }

  return config;
};
